module.exports = __webpack_public_path__ + "img/history-check-on1.png";